import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import Share from 'components/fragments/Share/Share';
const ShareComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/Share/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <Share {...props} />
  </ImagesProvider>
);

export default ShareComponent;
